import { render, staticRenderFns } from "./addTeamBuild.vue?vue&type=template&id=574a1487&scoped=true"
import script from "./addTeamBuild.vue?vue&type=script&lang=js"
export * from "./addTeamBuild.vue?vue&type=script&lang=js"
import style0 from "./addTeamBuild.vue?vue&type=style&index=0&id=574a1487&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574a1487",
  null
  
)

export default component.exports